var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.375,
    y: 12.75,
    width: 38.25,
    height: 25.5,
    rx: 3.76698,
    stroke: "url(#paint0_linear_1146_2369)",
    strokeWidth: 3.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 19.125H17",
    stroke: "url(#paint1_linear_1146_2369)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31.8752H38.25",
    stroke: "url(#paint2_linear_1146_2369)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 20.7197C28.1399 20.7197 30.2803 22.8601 30.2803 25.5C30.2803 28.1399 28.1399 30.2803 25.5 30.2803C22.8601 30.2803 20.7197 28.1399 20.7197 25.5C20.7197 22.8601 22.8601 20.7197 25.5 20.7197Z",
    stroke: "url(#paint3_linear_1146_2369)",
    strokeWidth: 3.19
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1146_2369",
    x1: 6.375,
    y1: 25.5,
    x2: 44.625,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1146_2369",
    x1: 12.75,
    y1: 19.625,
    x2: 17,
    y2: 19.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1146_2369",
    x1: 34,
    y1: 32.3752,
    x2: 38.25,
    y2: 32.3752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1146_2369",
    x1: 19.125,
    y1: 25.5,
    x2: 31.875,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.4ecd662ceb9f23bf842936d809e69a63.svg";
export { ForwardRef as ReactComponent };